import { useTranslation } from 'react-i18next';
import { useDecorator } from '../../utils/hooks';
import useFormattedCurrency from '../../components/Currency/useFormattedCurrency';

function useInstallmentDecorator() {
  return useDecorator<Installment, DecoratedInstallment>((installment: Installment) => {
    const formattedCurrency = useFormattedCurrency(installment.installmentValue);
    const formattedInterest = useFormattedCurrency(installment.amount - installment.subAmount);
    const { t } = useTranslation();

    return {
      name: `${installment.quantity}x ${formattedCurrency}`,
      interestText: installment.interest > 0 ? formattedInterest : t('noInterest'),
    };
  });
}

export default useInstallmentDecorator;
